import NoPermissionView from "./NoPermissionView";

export default NoPermissionView;
